export enum OPERATIONAL_MODES {
  ENERGY_ARBITRAGE = 'ENERGY_ARBITRAGE',
  SELF_CONSUMPTION = 'SELF_CONSUMPTION',
  BACKUP_ONLY = 'BACKUP_ONLY',
}
